export class InvalidRegExpError extends Error {
  constructor(expression: string) {
    super(`Invalid Regex expression: ${expression}`);
  }
}

/** This code creates a new RegEx from the expression string and returns the result. */
export const safeRegExp = (expression: string): RegExp | null => {
  try {
    return new RegExp(expression);
  } catch {
    console.warn(`Invalid`);
    throw new InvalidRegExpError(expression);
  }
};
